<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    import {getUserInfo, setSessionObj} from "./common/utils";
    import {myIdentify, myTrack} from "./common/track";

    export default {
        name: 'app',
        components: {},
        created() {
            // try {
                // myTrack("研发分析", {
                //     '地址路径': window.location.href,
                //     '使用程序': window.navigator.userAgent,
                //     '获取时间': new Date().getTime(),
                //     '大卡用户ID': getUrlParams().userId || "",
                // });
            // } catch (e) {
            // }
            if ((window.navigator.userAgent.indexOf("daka") > -1 || window.navigator.userAgent.indexOf("zjcw-app")> -1) && !getSessionObj("dakaUser")) {
                new Promise((resolve) => {
                    setTimeout(() => {
                        getUserInfo(resolve)
                    }, 500)
                }).then((e) => {
                    // this.zhugeT(e);
                    myIdentify(e)
                })
            } else if (window.navigator.userAgent.indexOf("daka") > -1 || window.navigator.userAgent.indexOf("zjcw-app")) {
                // this.zhugeT(getUserInfo());
                myIdentify(getUserInfo())
            }else{                    
                myIdentify();
            }
        },
        methods: {
            // zhugeT(info) {
            //     myTrack("getUserId正常获取", {
            //         'id': info.userId || "",
            //     });
            //     myIdentify(info.userId, {
            //         name: info.nickName,
            //         avatar: info.avatar,
            //         "用户性别": (function (sex) {
            //             if (sex === "1") {
            //                 return "男"
            //             } else if (sex === "2") {
            //                 return "女"
            //             } else {
            //                 return ""
            //             }
            //         })(info.sex),
            //         "注册时间": "",
            //         "用户生日": "",
            //         "绑定手机": info.mobile,
            //         "所在城市": "",
            //         "实名认证状态": ""
            //     });
            // }
        },
        mounted() {
            setSessionObj("failUrl", location.href)
        }
    }
</script>

<style lang="scss">
    body {
        background: #f5f5f9;
        font-size: 4vw;
        color: #333333;
    }

    html, body {
        height: 100vh;
        margin: 0;
        padding: 0;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
    }

    #app {
        height: 100vh;
        -webkit-overflow-scrolling: touch;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    input {
        display: inline-block;
        width: 43vw;
        height: 5.33vw;
        padding: 0;
        margin: 0;
        line-height: 5.33vw;
        font-size: 4vw;
        text-align: right;
        border: none;
        outline-style: none;
        vertical-align: middle;

        &::placeholder {
            color: #999999;
        }

        &:-moz-placeholder {
            color: #999999;
        }

        &::-webkit-input-placeholder {
            color: #999999;
        }

        &:-ms-input-placeholder {
            color: #999999;
        }
    }

    textarea {
        width: 53.55vw;
        height: 10.67vw;
        padding: 0;
        margin: 0;
        font-size: 4vw;
        vertical-align: middle;
        resize: none;
        border: none;
        outline-style: none;
        word-break: break-all;

        &::placeholder {
            line-height: 10.67vw;
            text-align: right;
            color: #999999;
        }

        &:-moz-placeholder {
            line-height: 10.67vw;
            text-align: right;
            color: #999999;
        }

        &::-webkit-input-placeholder {
            line-height: 10.67vw;
            text-align: right;
            color: #999999;
        }

        &:-ms-input-placeholder {
            line-height: 10.67vw;
            text-align: right;
            color: #999999;
        }
    }

    p {
        margin: 0;
    }
</style>
